import { memo } from "react";
import { PaymentProduct } from "consts/openBanking";
import withChipStatus from "./withChipStatus";

export default memo(withChipStatus<number>(
    new Map()
        .set(PaymentProduct.Domestic, {
            label: 'Domestic',
            color: 'info'
        })
        .set(PaymentProduct.Sepa, {
            label: 'SEPA',
            color: 'info'
        })
        .set(PaymentProduct.CrossBorder, {
            label: 'Cross Border',
            color: 'info'
        })
));
